// Copyright (c) 2022 by Move Closer

import { ref, Ref, watch } from '@vue/composition-api'

import { VideoProps } from '../../Video.contracts'

import { buildYouTubeVideoSrc } from './YouTubeVideo.helpers'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface UseYoutubeVideoProvides {
  /**
   * Determines the correct implementation of youtube embed url.
   */
  src: Ref<string>
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const useYoutubeVideo = (props: VideoProps): UseYoutubeVideoProvides => {
  const rawSource: string = buildYouTubeVideoSrc(props.source)
  const src = ref<string>(rawSource)

  src.value = `${rawSource}?autoplay=${+props.autoplay}&mute=${+props.isMuted}&controls=${+props.showControls}`

  /**
   * Watches for changes of isVideoPlaying
   */
  watch<boolean>(() => props.isPlaying, (value, oldValue) => {
    if (value === oldValue || !value) {
      return
    }

    src.value = `${rawSource}?autoplay=1&mute=${+props.isMuted}&controls=${+props.showControls}`
  })

  return { src }
}
